export const tableSolubilitiesHeader = [
  {
    data: "solvent",
    title: "Solvent",
    className: "table-solubilities__header-cell"
  },
  {
    data: "measure",
    title: "Measure",
    className: "table-solubilities__header-cell"
  },
  {
    data: "conc",
    title: "Concentration",
    className: "table-solubilities__header-cell"
  },
  {
    data: "unit",
    title: "Unit",
    className: "table-solubilities__header-cell"
  },
  {
    data: "comment",
    title: "Comment",
    className: "table-solubilities__header-cell"
  }
];

export const optionsMass = [
  {
    value: 15,
    label: "kg"
  },
  {
    value: 12,
    label: "g"
  },
  {
    value: 9,
    label: "mg"
  },
  {
    value: 6,
    label: "μg"
  },
  {
    value: 0,
    label: "pg"
  }
];
export const optionsConcentration = [
  {
    value: 12,
    label: "M"
  },
  {
    value: 9,
    label: "mM"
  },
  {
    value: 6,
    label: "μM"
  },
  {
    value: 3,
    label: "nM"
  },
  {
    value: 0,
    label: "pM"
  }
];
export const optionsVolume = [
  {
    value: 6,
    label: "L"
  },
  {
    value: 3,
    label: "mL"
  },
  {
    value: 0,
    label: "μL"
  }
];

export const optionsConcentrationEnd = [
  {
    value: 12,
    label: "M"
  },
  {
    value: 9,
    label: "mM"
  },
  {
    value: 6,
    label: "μM"
  },
  {
    value: 3,
    label: "nM"
  },
  {
    value: 0,
    label: "pM"
  }
];
export const optionsConcentrationStart = [
  {
    value: 12,
    label: "M"
  },
  {
    value: 9,
    label: "mM"
  },
  {
    value: 6,
    label: "μM"
  },
  {
    value: 3,
    label: "nM"
  },
  {
    value: 0,
    label: "pM"
  }
];
export const optionsVolumeEnd = [
  {
    value: 6,
    label: "L"
  },
  {
    value: 3,
    label: "mL"
  },
  {
    value: 0,
    label: "μL"
  }
];
export const optionsVolumeStart = [
  {
    value: 6,
    label: "L"
  },
  {
    value: 3,
    label: "mL"
  },
  {
    value: 0,
    label: "μL"
  }
];
